<template>
    <div class="animated fadeIn detail-pusat-page">
            <button type="button" class="btn btn-back mb-3" @click="$router.go(-1)" name="backBtn">
                <i class="fa fa-angle-left mr-1"></i> Back
            </button>
            <div class="detail-pusat-card">
                <h4 class="page-title mb-4">Detail Daftar Cek Gadai</h4>
        <DetailGadaiKomp :detailGadai="dataCekGadai.gadaiDetail" />
        <div v-if="dataCekGadai.ku != null" class="detail-data-wrapper mt-4 mb-4">
            <h6 class="form-title">LAPORAN KEPALA UNIT</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Nama</b-col>
                <b-col>{{ dataCekGadai.ku.name }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Status</b-col>
                <b-col>{{ dataCekGadai.ku.status }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                <b-col v-if="dataCekGadai.ku.processedAt != null">
                    {{ $helper.changeDateFormat(dataCekGadai.ku.processedAt) }} {{ $helper.changeDateFormatGetHour(dataCekGadai.ku.processedAt) }}
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                <b-col v-if="dataCekGadai.ku.keterangan != null">{{ dataCekGadai.ku.keterangan }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div v-if="dataCekGadai.kc != null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">LAPORAN KEPALA CABANG</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Nama</b-col>
                <b-col>{{ dataCekGadai.kc.name }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Status</b-col>
                <b-col>{{ dataCekGadai.kc.status }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                <b-col v-if="dataCekGadai.kc.processedAt != null">
                    {{ $helper.changeDateFormat(dataCekGadai.kc.processedAt) }} {{ $helper.changeDateFormatGetHour(dataCekGadai.kc.processedAt) }}
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                <b-col v-if="dataCekGadai.kc.keterangan != null">{{ dataCekGadai.kc.keterangan }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div v-if="dataCekGadai.kcs != null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">LAPORAN KEPALA CABANG SENIOR</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Nama</b-col>
                <b-col>{{ dataCekGadai.kcs.name }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Status</b-col>
                <b-col>{{ dataCekGadai.kcs.status }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                <b-col v-if="dataCekGadai.kcs.processedAt != null">
                    {{ $helper.changeDateFormat(dataCekGadai.kcs.processedAt) }} {{ $helper.changeDateFormatGetHour(dataCekGadai.kcs.processedAt) }}
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                <b-col v-if="dataCekGadai.kcs.keterangan != null">{{ dataCekGadai.kcs.keterangan }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>
            </div>
    </div>
</template>

<script>

import DetailGadaiKomp from '../../../components/gadai/DetailGadaiKomp'

export default {
    name: 'detail-cek-gadai',
    components: {
        DetailGadaiKomp
    },
    props: {
        dataCekGadai: { type: Object, required: true }
    },
}
</script>


<style lang="scss" scoped>
// Design System Tokens (Deep Pine Palette)
$deep-pine: #023831;
$deep-pine-hover: #0A5247;
$brass: #C69B6B;
$ink-body: #16302B;
$ink-heading: #072D28;
$ink-muted: #7E918B;
$line-border: #E2E7E3;
$input-border: #D8E2DC;

.detail-pusat-page {
    padding-bottom: 30px;
}

.detail-pusat-card {
    background-color: #FFFFFF;
    border: 1px solid $line-border;
    border-radius: 12px;
    padding: 24px 28px 28px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.page-title {
    font-size: 20px;
    font-weight: 700;
    color: $ink-heading;
    letter-spacing: -0.01em;
}

// Judul seksi: batang aksen brass + garis bawah
::v-deep .detail-data-wrapper h6.form-title,
::v-deep .form-content-wrapper h6.form-title {
    position: relative;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: $ink-heading;
    padding-left: 12px;
    padding-bottom: 8px;
    margin-bottom: 14px;
    border-bottom: 1px solid #EDF2EF;

    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 1px;
        width: 3px;
        height: 13px;
        border-radius: 2px;
        background-color: $brass;
    }
}

::v-deep .detail-data-wrapper {
    margin-bottom: 28px;
}

// Baris label / nilai
::v-deep .row.mb-2 {
    padding-bottom: 8px;
    margin-left: 0;
    margin-right: 0;
    font-size: 13px;
    color: $ink-body;
}

::v-deep .detail-data-label {
    font-weight: 500;
    font-size: 13px;
    color: #6E827C;
    overflow-wrap: break-word;

    strong { font-weight: 600; }
}

// Form
::v-deep .form-group label {
    font-size: 13px;
    font-weight: 600;
    color: $ink-body;
    margin-bottom: 8px;
}

::v-deep .field-input,
::v-deep .field-select,
::v-deep textarea.form-control,
::v-deep input.form-control,
::v-deep select.form-control {
    border-radius: 8px;
    border: 1px solid $input-border;
    font-size: 13px;
    color: $ink-body;
    padding: 8px 14px;

    &:focus {
        border-color: $deep-pine;
        box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
        outline: none;
    }
}

::v-deep textarea.form-control { min-height: 96px; }

// Gambar bukti
::v-deep .detail-data-wrapper img {
    border-radius: 8px;
    border: 1px solid $line-border;
}

// Tabel di dalam detail
::v-deep .table thead th {
    background-color: #F5FAF7;
    border-top: none;
    border-bottom: 1px solid $line-border;
    font-size: 11px;
    font-weight: 700;
    color: #4A5D56;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 12px 16px;
}

::v-deep .table tbody td {
    padding: 12px 16px;
    border-top: 1px solid #EDF2EF;
    font-size: 13px;
    color: $ink-body;
    vertical-align: middle;
}

// Tombol aksi
.detail-actions-footer {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 24px;
}

.btn-submit {
    background-color: $deep-pine;
    border: 1px solid $deep-pine;
    color: #FFFFFF;
    border-radius: 8px;
    padding: 10px 24px;
    font-size: 13.5px;
    font-weight: 700;
    transition: all 0.2s ease;

    &:hover {
        background-color: $deep-pine-hover;
        border-color: $deep-pine-hover;
        color: #FFFFFF;
    }
}

.btn-cancel {
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 13.5px;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
        background-color: #F4F7F5;
        border-color: #BAC9C2;
        color: $ink-heading;
    }
}

.btn-danger-outline {
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: #9B4A3C;
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 13.5px;
    font-weight: 600;
    transition: all 0.2s ease;

    &:hover {
        background-color: #F9EDEB;
        border-color: #E4C4BD;
        color: #9B4A3C;
    }
}
</style>
